import { Button, Text } from '@vimeo/bokeh';
import { CommentList } from '@vimeo/bokeh-icons';

import { T } from '../../translations';

type Props = {
  canAddComments: boolean;
  saveViewerCommentsSetting?: (allowViewerComments: boolean) => void;
  hasComments: boolean;
  isPublic: boolean;
  hasOnlyCommentAccess?: boolean;
  isPreviousVersion?: boolean;
  reviewId?: string;
};

export const CommentsEmptyState = ({
  saveViewerCommentsSetting,
  canAddComments,
  hasComments,
  isPublic,
  hasOnlyCommentAccess,
  isPreviousVersion = false,
  reviewId,
}: Props) => {
  const getEmptyStateMessage = () => {
    if (isPreviousVersion) {
      if (!hasComments) {
        return !!reviewId ? T.NoComments : T.NoCollaboratorsComment;
      }
      return;
    }

    if (reviewId) {
      return T.NoCommentsYet;
    }

    // In VH page we dont allow to change the viewers comment setting and show a different message.
    if (canAddComments) {
      if (isPublic) {
        if (saveViewerCommentsSetting) {
          return T.NoViewersCommentYet;
        }
        return T.NoCommentsYet;
      }
      return T.NoCollaboratorsCommentYet;
    } else if (saveViewerCommentsSetting) {
      return T.ViewersCanNotPostNewComments;
    } else {
      return T.NoCommentsAllowed;
    }
  };

  return (
    <>
      <CommentList boxSize={hasComments ? 'sm' : 'lg'} color="text-primary" />
      <Text variant="heading-xs" fontWeight="350" textAlign="center" color="text-secondary">
        {getEmptyStateMessage()}
      </Text>
      {saveViewerCommentsSetting && !canAddComments && !hasOnlyCommentAccess && (
        <Button
          variant="primary"
          size={hasComments ? 'xs' : 'sm'}
          onClick={() => saveViewerCommentsSetting(!canAddComments)}
        >
          {T.AllowComments}
        </Button>
      )}
    </>
  );
};
